export const Footer = () => (
  <footer className="border-t border-white/5 mt-32" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 flex flex-col md:flex-row justify-between gap-6">
      <div>
        <span className="flex items-center gap-3"><img src="/logo.svg" alt="" className="w-9 h-9" /><span className="font-serif text-2xl"><em className="text-[#D4AF37]">Your</em>Hostess</span></span>
        <p className="text-sm text-neutral-500 mt-2 max-w-sm">Hostess e modelle professioniste per eventi, fiere e campagne in tutta Italia.</p>
      </div>
      <p className="text-xs text-neutral-600 font-mono self-end">© 2026 YourHostess</p>
    </div>
  </footer>
);
